import { types } from "./types";

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_USER.SUCCESS:
      return { ...state, ...action.payload };
    case types.LOGOUT_USER.SUCCESS:
      return initialState;
    case types.UPDATE_FIRST_LOGIN.SUCCESS:
      return { ...state, firstLogin: false}
    default:
      return state;
  }
}

export default reducer;